import React, { useEffect, useState } from "react";
import CG_FooterButtons from "./CG_FooterButtons";
import CG_Header from "./CG_Header";
import CG_PropertyDetails from "./CG_PropertyDetails";
import CG_OfferDetails from "./CG_OfferDetails";
import CG_FinancingInfo from "./CG_FinancingInfo";
import CG_AdditionalTermsConditions from "./CG_AdditionalTermsConditions";
import { useNavigate } from "react-router-dom";
import config from "../../config";

export default function QuestionAireScreen() {
    const navigate = useNavigate();
    const [currentScreen, setCurrentScreen] = useState(0);
    const [formData, setFormData] = useState({});
    const [prefill_answers, setPrefill_answers] = useState([]);

    useEffect(() => {
        documentPrefillAnswerApi();
    }, []);
    const documentPrefillAnswerApi = async () => {
        let payload = {
            street_number: "3340",
            street_name: "Colfax",
            city: "Minneapolis",
            state: "MN",
            required_fields: ["field1", "field2"],
        };
        const accessToken = localStorage.getItem("authUser");
        const token = accessToken ? accessToken.replace(/^"|"$/g, "") : "";
        try {
            let url = config.get("API_URL") + "/docs/prefill-answers";

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            setPrefill_answers(data.data);
        } catch (error) {
            console.log("🚀 ~ documentPrefillAnswerApi ~ error:", error);
        }
    };

    return (
        <div className=" tw-h-screen ">
            <CG_Header />
            <div className=" tw-h-full  tw-text-[#001659]">
                <h1 className="tw-underline tw-text-center tw-font-[700] tw-text-[30px] tw-text-[#001659]">Questionnaire</h1>

                {currentScreen === 0 && (
                    <CG_PropertyDetails
                        setFormData={setFormData}
                        formData={formData}
                        currentScreen={currentScreen}
                        setCurrentScreen={setCurrentScreen}
                        navigate={navigate}
                    />
                )}
                {currentScreen === 1 && (
                    <CG_OfferDetails
                        setFormData={setFormData}
                        formData={formData}
                        currentScreen={currentScreen}
                        setCurrentScreen={setCurrentScreen}
                        navigate={navigate}
                    />
                )}
                {currentScreen === 2 && (
                    <CG_FinancingInfo
                        setFormData={setFormData}
                        formData={formData}
                        currentScreen={currentScreen}
                        setCurrentScreen={setCurrentScreen}
                        navigate={navigate}
                    />
                )}
                {currentScreen === 3 && (
                    <CG_AdditionalTermsConditions
                        setFormData={setFormData}
                        formData={formData}
                        currentScreen={currentScreen}
                        setCurrentScreen={setCurrentScreen}
                        navigate={navigate}
                    />
                )}
            </div>
            {/* <CG_FooterButtons currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} navigate={navigate} /> */}
        </div>
    );
}
